import { css } from '@emotion/react';
import { Box, Stack, Typography } from '@mui/material';
import { Types } from '@scorenco/core';

import { Wrapper, Image, Markdown } from '../../primitives';

type TeamSliceProps = {
  slice: Types.ComponentSlicesTeam;
};

export const TeamSlice = ({ slice }: TeamSliceProps) => {
  return (
    <Wrapper marginY={7}>
      <Stack
        flexWrap="wrap"
        direction="row"
        justifyContent="space-evenly"
        alignItems="start"
        gap={6}
      >
        {slice.members?.map((member) => {
          if (!member) {
            return null;
          }

          return (
            <Box
              key={member.id}
              css={css`
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                max-width: 18rem;
              `}
              maxWidth="sm"
            >
              <Image
                src={member.picture?.url}
                css={css`
                  display: block;
                  padding-left: 2rem;
                  padding-right: 2rem;
                  width: 100%;
                  object-fit: contain;
                `}
              />
              <Typography
                component="p"
                css={(theme) => css`
                  margin-top: ${theme.spacing(2)};
                  text-align: center;
                  line-height: 1em;
                  margin-bottom: ${theme.spacing(1)};
                  font-weight: bolder;
                `}
              >
                {member.name}
              </Typography>
              {member.role && (
                <Typography
                  component="p"
                  css={(theme) => css`
                    text-align: center;
                    line-height: 1em;
                    margin-bottom: ${theme.spacing(1)};
                    font-style: italic;
                  `}
                >
                  {member.role}
                </Typography>
              )}
              <Typography
                component="p"
                css={css`
                  text-align: center;
                  font-size: 0.9em;
                `}
              >
                <Markdown value={member.description} isInline={true} />
              </Typography>
            </Box>
          );
        })}
      </Stack>
    </Wrapper>
  );
};
